export const PRODUCTION_TRANSACTION_REQUEST = 'PRODUCTION_TRANSACTION_REQUEST';
export const PRODUCTION_TRANSACTION_REQUEST_FAILURE = 'PRODUCTION_TRANSACTION_REQUEST_FAILURE';
export const GET_PRODUCTION_TRANSACTIONS = 'GET_PRODUCTION_TRANSACTIONS';
export const GET_PRODUCTION_TRANSACTIONS_TAKA_NO = 'GET_PRODUCTION_TRANSACTIONS_TAKA_NO';
export const GET_PRODUCTION_TRANSACTIONS_BY_BEAM = 'GET_PRODUCTION_TRANSACTIONS_BY_BEAM';
export const SET_SELECTED_BEAM = 'SET_SELECTED_BEAM';
export const GET_PRODUCTION_TRANSACTIONS_WITH_SPECIFIC_COLUMNS = 'GET_PRODUCTION_TRANSACTIONS_WITH_SPECIFIC_COLUMNS';